export enum ViewColumnsAddSectionBlock {
  Root = 'ViewColumnsAddSection',
}

export enum ViewColumnsAddSectionModifier {
  Highlighted = 'highlighted',
}
